export default __webpack_public_path__ + "static/machineLearning-56bc6cb57ae46a81a744bc2f14b26d90.svg";